<template>
  <Teleport to="body">
    <Transition name="modal-fade">
      <div v-if="visible" class="modal-overlay" @click.self="close">
        <div class="custom-modal">
          <div class="modal-header">
            <h3>网盘提取码</h3>
            <button class="close-btn" @click="close">
              <i class="fa-solid fa-times"></i>
            </button>
          </div>
          
          <div class="modal-body">
            <div class="icon-wrapper">
              <i class="fa-solid fa-key"></i>
            </div>
            <div class="tip-text">
              当前备用网盘链接的提取码：
            </div>
            <div class="code-box">
              {{ code }}
            </div>
          </div>
          
          <div class="modal-footer">
            <button class="cancel-btn" @click="close">取消</button>
            <button class="confirm-btn" @click="confirm">复制提取码并跳转</button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'CloudCodeModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    }
  },
  emits: ['update:visible', 'confirm'],
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-dialog);

}

.custom-modal {
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 80vh;
}

.modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-family: '猫啃网糖圆体';
  font-size: 1.2em;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 30px 20px;
  flex: 1;
  overflow-y: auto;
  text-align: center;
}

.icon-wrapper {
  margin-bottom: 15px;
}

.icon-wrapper i {
  font-size: 40px;
  color: #E6A23C;
}

.tip-text {
  color: #666;
  font-size: 1em;
  margin-bottom: 15px;
  font-family: '爱点风雅黑';
}

.code-box {
  background: #fff9e6;
  border: 1px dashed #E6A23C;
  color: #E6A23C;
  padding: 12px;
  border-radius: 8px;
  font-family: monospace;
  font-size: 1.5em;
  font-weight: bold;
  letter-spacing: 2px;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.cancel-btn {
  padding: 8px 20px;
  border: none;
  background: #f5f5f5;
  color: #666;
  border-radius: 20px;
  cursor: pointer;
  font-family: '爱点风雅黑';
  transition: all 0.3s;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.confirm-btn {
  padding: 8px 20px;
  border: none;
  background: linear-gradient(135deg, #E6A23C 0%, #d8962e 100%);
  color: white;
  border-radius: 20px;
  cursor: pointer;
  font-family: '爱点风雅黑';
  transition: all 0.3s;
}

.confirm-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(230, 162, 60, 0.3);
}

/* Dark Theme Support */
.dark-theme .custom-modal {
  background: #2d2d2d;
  color: #fff;
}

.dark-theme .modal-header {
  border-bottom-color: #3d3d3d;
}

.dark-theme .modal-header h3 {
  color: #fff;
}

.dark-theme .close-btn {
  color: #aaa;
}

.dark-theme .tip-text {
  color: #ccc;
}

.dark-theme .code-box {
  background: rgba(230, 162, 60, 0.1);
  border-color: #E6A23C;
}

.dark-theme .modal-footer {
  border-top-color: #3d3d3d;
}

.dark-theme .cancel-btn {
  background: #383838;
  color: #ccc;
}

.dark-theme .cancel-btn:hover {
  background: #444;
}

/* Animations */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .custom-modal {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-fade-leave-active .custom-modal {
  transition: transform 0.3s ease-in;
}

.modal-fade-enter-from .custom-modal {
  transform: scale(0.9) translateY(10px);
}

.modal-fade-leave-to .custom-modal {
  transform: scale(0.95) translateY(10px);
}

@media (max-width: 480px) {
  .custom-modal {
    width: 100%;
    border-radius: 20px 20px 0 0;
    position: absolute;
    bottom: 0;
    margin: 0;
    max-width: none;
    max-height: 90vh;
  }
  
  .modal-overlay {
    align-items: flex-end;
  }
  
  .modal-fade-enter-from .custom-modal,
  .modal-fade-leave-to .custom-modal {
    transform: translateY(100%);
  }
}
</style>
